import React, {useState} from "react";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {isBotThinkingSelector, sendMessageToBot} from "../chatbotSlice";
import {InputType} from "../../api/generated";

export const InputField: React.FC = () => {

    const dispatch = useAppDispatch();

    const [text, setText] = useState<string>("");

    const sendUserMessageToBot = (userMessage: any) => {
        dispatch(sendMessageToBot({message: userMessage, inputType: InputType.Manual}))
    };

    const thinking = useAppSelector(isBotThinkingSelector);

    return <div className="flex justify-between text-sm mt-4">
        <div
            className="border-[1px] w-full h-[52px] rounded-[8px] flex justify-between items-end mx-2 bg-white">
            <input
                onChange={(e) => setText(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === "Enter" && !thinking) {
                        e.preventDefault();
                        if (text.length > 0) {
                            sendUserMessageToBot(text);
                            setText("");
                        }
                    }
                }}
                value={text}
                placeholder="Type your message..."
                className="placeholder-gray-600 bg-transparent outline-[none] selectionText ml-3 w-full leading-[48px] transition-all duration-200 resize-none border-2 border-none outline-none whitespace-pre-wrap break-words selection:border-blue-800 text-base target:border-none active:border-none border-blue-800 focus:border-blue-900 focus-within:border-blue-900 focus-visible:border-none"
            />
            <button
                onClick={(e) => {
                    if (text.length > 0 && !thinking) {
                        sendUserMessageToBot(text);
                        setText("");
                    }
                }}
                className="w-12 h-full flex justify-center align-content-center items-center rounded-full"
            >
                <svg width="20" height="16" viewBox="0 0 20 16" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.5 16V10L8.5 8L0.5 6V0L19.5 8L0.5 16Z" fill="black"/>
                </svg>
            </button>
        </div>
    </div>
}
